import React, { useState, useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import GroupMasterReport from "./GroupMasterReport";
import GroupSalesReport from "./GroupSalesReport";
import GroupChannelManagerReport from "./GroupChannelManagerReport";
import { useHistory, useLocation } from "react-router-dom";
import GroupRoomRevenueReport from "./GroupRoomRevenueReport";
import GroupPaymentsReport from "./GroupPaymentsReport";
import GroupRoomInventoryReport from "./GroupRoomInventoryReport";
import GroupCashCounterReport from "./GroupCashCounterReport";
import GroupPaymentGatewayReport from "./GroupPaymentGatewayReport";
import axios from "axios";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import i18n from "../../modules/Auth/pages/i18n";
import Header from "../BookingDashboard/Header";
import GroupTransferReport from "./GroupTransferReport";

// Card
const Card = ({ report }) => {
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    async function getLastUpdated() {
      if (report.hasOwnProperty("lastUpdated")) {
        const time = await report.lastUpdated();
        setLastUpdated(time);
      }
    }
    getLastUpdated();
  }, [report.stateVal, report]);

  return (
    <div className="reportsTypeCards">
      <div className="reportsTypeBody">
        <h2>{report.name}</h2>
        {lastUpdated && (
          <h5>
            <i style={{ fontSize: "12.5px" }}>Last updated {lastUpdated}</i>
          </h5>
        )}
        <p>{report.description}</p>
      </div>
    </div>
  );
};

function GroupReportsContainer({ email, selectedLanguage }) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);
  const history = useHistory();
  const location = useLocation();
  // Set the state of reports and render accordingly
  // const [reportState, setReportState] = useState("default");
  // Reset to default state
  // function performResetOperation() {
  //   setReportState("default");
  // }

  // Check when the group reports were updated
  // const [lastUpdatedGrpReports, setLastUpdatedGrpReports] = useState(null);
  async function handleGetUpdateStautsOfGrpReports(reportType) {
    let res = "";
    try {
      res = await axios.get(
        `https://loadapi.stayflexi.com/core/api/v1/reports/last-updated-time-group-reports/?reportType=${reportType}`
      );
    } catch (error) {
      res = "";
    }
    return res.data;
  }

  // Group reports
  const grpReports = [
    {
      name: `${t("Group master report")}`,
      active: true,
      stateVal: "grpMaster",
      url: "/hotel-dashboard/group-master-report",
      description: `${t(
        "Get all the details of bookings, customer information, payments, and taxes across all the hotels in a single report. "
      )}`,
      componentRender: (
        <GroupMasterReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />
      ),
      // lastUpdated: () => handleGetUpdateStautsOfGrpReports("master"),
    },
    {
      name: `${t("Group sales report")}`,
      active: false,
      stateVal: "grpSales",
      url: "/hotel-dashboard/group-sales-report",
      description: `${t(
        "Date-wise performance report of the all the hotels in the group. Occupancy, ADR, RevPAR, Revenue, payments, and other vital metrics."
      )}`,
      componentRender: (
        <GroupSalesReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />
      ),
      lastUpdated: () => handleGetUpdateStautsOfGrpReports("sales"),
    },
    {
      name: `${t("Group channel manager report")}`,
      active: false,
      stateVal: "grpCmReport",
      url: "/hotel-dashboard/group-cm-report",
      description: `${t(
        "Report of all the bookings received from various channels across all the hotels in the group."
      )}`,
      componentRender: (
        <GroupChannelManagerReport
          selectedLanguage={selectedLanguage}
          grpEmail={email}
          resetToDefault={""}
        />
      ),
      lastUpdated: () => handleGetUpdateStautsOfGrpReports("channelManager"),
    },
    {
      name: `${t("Group room revenue report")}`,
      active: true,
      stateVal: "grpRoomRev",
      url: "/hotel-dashboard/group-roomrev-report",
      description: `${t("Group room revenue report")}`,
      componentRender: (
        <GroupRoomRevenueReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />
      ),
      // lastUpdated: () => handleGetUpdateStautsOfGrpReports("roomRevenue"),
    },
    {
      name: `${t("Group gateway payments report")}`,
      active: false,
      stateVal: "grpGatewayPayment",
      url: "/hotel-dashboard/group-payments-report",
      description: `${t("Group gateway payment report")}`,
      componentRender: (
        <GroupPaymentsReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />
      ),
      lastUpdated: () => handleGetUpdateStautsOfGrpReports("payment"),
    },
    {
      name: `${t("Group Room Inventory report")}`,
      active: ["madhur@sliceinn.in",
         "bigfootoperations@gmail.com", 
         "pavan.varanasi@stayflexi.com", 
         "ankitsinhastayflexitest@gmail.com",
         "arun.e@stayflexi.com"
        ].includes(email),
      stateVal: "groupRoomInventoryReport",
      url: "/hotel-dashboard/group-room-inventory-report",
      description: `${t(
        "Get all the details of room inventory across all the hotels in a single report. "
      )}`,
      componentRender: 
        <GroupRoomInventoryReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />,
    },
    {
      name: `${t("Group Cash Counter report")}`,
      active: [
        "madhur@sliceinn.in",
        "bigfootoperations@gmail.com", 
        "pavan.varanasi@stayflexi.com", 
        "ankitsinhastayflexitest@gmail.com",
        "arun.e@stayflexi.com"
      ].includes(email),
      stateVal: "groupCashCounterReport",
      url: "/hotel-dashboard/group-cash-counter-report",
      description: `${t(
        "Get all the details of cash counter transactions across all the hotels in a single report. "
      )}`,
      componentRender: 
        <GroupCashCounterReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />,
    },
    {
      name: `${t("Group Transfers report")}`,
      active: [
        "madhur@sliceinn.in",
        "ankitsinhastayflexitest@gmail.com",
        "pavan.varanasi@stayflexi.com",
        "arun.e@stayflexi.com"
      ].includes(email),
      stateVal: "groupCashCounterReport",
      url: "/hotel-dashboard/group-transfer-report",
      description: `${t(
        "Get all the details of transfers across all the hotels in a single report. "
      )}`,
      componentRender: 
        <GroupTransferReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />,
    },
    {
      name: `${t("Group Payment Gateway report")}`,
      active: [
        "madhur@sliceinn.in",
        "ankitsinhastayflexitest@gmail.com",
        "pavan.varanasi@stayflexi.com",
        "arun.e@stayflexi.com",
      ].includes(email),
      stateVal: "groupPgReport",
      url: "/hotel-dashboard/group-payment-gateway-report",
      description: `${t(
        "Get all the details of payment gateway transactions across all the hotels in a single report. "
      )}`,
      componentRender: 
        <GroupPaymentGatewayReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />,
    },
    {
      name: `${t("Group Channel Manager report")}`,
      active: [
        "madhur@sliceinn.in",
        "ankitsinhastayflexitest@gmail.com",
        "pavan.varanasi@stayflexi.com",
        "arun.e@stayflexi.com",
      ].includes(email),
      stateVal: "groupChannelManagerReport",
      url: "/hotel-dashboard/group-channel-manager-report",
      description: `${t(
        "Get all the details of channel manager transactions across all the hotels in a single report. "
      )}`,
      componentRender: 
        <GroupChannelManagerReport
          grpEmail={email}
          resetToDefault={""}
          selectedLanguage={selectedLanguage}
        />,
    },
  ];

  return (
    <Stack style={{ width: "100%", height: "100%" }}>
      <Header title={"Group reports"} mode={"light"} />
      <Typography
        style={{
          position: "relative",
          marginLeft: "10px",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {t(
          "Group reports provide data for a 6-month period in the past as well as a 6-month outlook into the future. If you need information beyond this 12-month range, please refer to the individual property reports."
        )}
      </Typography>
      <Stack
        direction={"row"}
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          alignContent: "flex-start",
          alignItems: "flex-start",
          margin: "10px",
        }}
      >
        {grpReports
          .filter((report) => report.active === true)
          .map((item, index) => (
            <Stack
              onClick={() =>
                history.push({
                  pathname: item.url,
                  state: {
                    selectedSection: location.state.selectedSection,
                    childSectionName: "group-reports",
                    childSection: true,
                    groupEmail: email,
                  },
                })
              }
              key={index}
              style={{ marginBottom: "12.5px", marginRight: "12.5px" }}
            >
              <Card report={item} />
            </Stack>
          ))}
      </Stack>
    </Stack>
  );
}

export default GroupReportsContainer;
